import { Cicon } from "../Cicon";
import { Ctext } from "../Ctext";
import { ColorType } from "@/theme/colors";
import type { CdropdownOption } from "./Cdropdown.types";
import type { DropdownOptionViewState } from "./option-state";
import { buildOptionIconFrameStyle, buildOptionLabelStyle, resolveOptionIconColor, resolveOptionIconOpacity, resolveOptionLabelWeight, } from "./dropdown-option-styles";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface DropdownOptionDefaultContentProps {
    dataElScope: DataElScope;
    option: CdropdownOption;
    viewState: DropdownOptionViewState;
}
export function DropdownOptionDefaultContent({ dataElScope, option, viewState, }: DropdownOptionDefaultContentProps) {
    const optionIdentity = option.key ?? option.label;
    return (
      <div data-el={dataEl(dataElScope, "OptionDefaultContent/Root")} style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
        }}>
        {option.icon && (<div data-el={dataEl(dataElScope, "OptionDefaultContent/IconFrame")} style={buildOptionIconFrameStyle(viewState)}>
            <Cicon icon={option.icon} size={18} color={resolveOptionIconColor(viewState)} opacity={resolveOptionIconOpacity(viewState)} style={{
                transition: "color 200ms ease, opacity 200ms ease",
            }}/>
          </div>)}
        <Ctext size={15} weight={resolveOptionLabelWeight(viewState)} color={ColorType.White} opacity={viewState.textOpacity} style={buildOptionLabelStyle(viewState)}>
          {option.label}
        </Ctext>
      </div>
    );
}
